export const route = [
    {
        path: '/cooperative-company',
        name: 'cooperative-company',
        redirect: '/cooperative-company/list',
        component: () => import('./view/Main.vue'),
        children: [
            {
                path: '/cooperative-company/list',
                name: 'cooperative-company-list',
                component: () => import('./view/cooperative-company-list/CooperativeCompanyList/CooperativeCompanyList.vue'),
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.company_man',
                            to: { name: 'companies' },
                        },
                        {
                            text: 'backoffice.nav.whitelist',
                            active: true,
                        }
                    ],
                    permission: 'CooperativeCompaniesList',
                },
            }
        ],
    }
];
